import { render, staticRenderFns } from "./SingleCommodityTable.vue?vue&type=template&id=74caec2f&scoped=true&"
import script from "./SingleCommodityTable.vue?vue&type=script&lang=js&"
export * from "./SingleCommodityTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleCommodityTable.vue?vue&type=style&index=0&id=74caec2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74caec2f",
  null
  
)

export default component.exports